
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import config from '../../../config'
import Header from '../../Header';
import Footer from '../../Pages/Footer';
import Connectwallet from '../Login/Connect_wallet';
import Google from '../../Pages/Presale/IconBox/Google'
import Thanks from '../Login/Thanks'
// import Selectmethod from './Selectmethod';
import Selectmethod from '../Login/Selectmethod';
import Qrcode from '../Login/Qrcode';
import '../../Pages/css/emailconfirmation.css';
import { Container, Row, Col, Card, Button, Form, InputGroup } from 'react-bootstrap';
import * as ACTIONTYPES from '../../../redux/actionTypes'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { Spin } from 'antd';
import { ERROR, Success, Warning } from '../../../utils/errors';
import { userlogin } from '../../../services/apiServices';
import { useDispatch } from 'react-redux';
import { FaRegEye } from "react-icons/fa";

const LoadingPopup = () => {
	return (
		<div className="loading-popup-container">
			<div className="loading-popup">
				<p>Please wait</p>
				<h1>Loggin in . . .</h1>
			</div>
		</div>
	);
};

const Emailconfirmation = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [showLoading, setShowLoading] = useState(false)
	const [isLoading, setIsLoading] = useState(false);
	const [passwordicon, setPasswordicon] = useState(0);

	const submitForm = async (values) => {
		setShowLoading(true)

		const payload = {
			"emailAddress": values.userName,
			"password": values.password
		}
		try {

			const { data: response } = await userlogin(payload)
			setShowLoading(false)
			if (response.status) {
				response.data.isLogin = true;
				dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
				dispatch({ type: ACTIONTYPES.USERLOGIN, payload: response.data, token: response?.data?.accessToken });
				// Success(response.message)
				navigate(`${config.baseurl}`);
			} else {
				Warning(response.message)
			}
		} catch (error) {
			setShowLoading(false)
			console.log('error', error)
			ERROR("Invalid email or password")
		}
	}


	return (
		<>
			{/* <Header /> */}

			<section className="login-section">
				<div className="login-container">
					<Container fluid className='px-0'>
						<Row className="justify-content-center">
							<Col lg={12}>
								<Row className=''>
									<Col lg={5} md={5} xs={12} className=''>
										<div className="login-form">
											<div className="">
												<img
													src="assets/images/login/coinsbackImg.svg"
													alt="logo" className='coinsbackImg'
												/>
											</div>
										</div>
									</Col>
									<Col lg={7} md={7} xs={12} className=''>
										<Spin spinning={showLoading} >
											{/* <div className="loginDiv" style={{ minHeight: "368px" }}> */}
											<div className="loginDiv pt-5">
												<Row>
													<Col lg={7} className='mx-auto'>
														<div className='form_content'>
															<Form className='px-4'>
																<div className='formDiv'>
																	<div>
																		<img src="assets/images/emailconfirmImg.png" className="emailconfirmImg" />
																	</div>
																	<div className='text-center formheadbox'>
																		<h1 className='text-primary fw-bold mb-1'>Thanks!</h1>
																		<p className=''>We've sent a confirmation email to  <Link className='colorcode1 text-decoration-none' to={`${config.baseurl}signup`}>anubhasinghanim@gmail.com</Link></p>
																		{/* <Button variant='default' className='px-4 bg-transparent border border-secondary'><Google className="me-2" />&nbsp;&nbsp;Sign up with Google</Button> */}
																	</div>
																</div>
															</Form>

														</div>
													</Col>
												</Row>
											</div>
										</Spin>
									</Col>
								</Row>
							</Col>
						</Row>
					</Container>



				</div>


			</section>

			{/* <Footer /> */}
			{isLoading && <LoadingPopup />}

		</>
	)
}

export default Emailconfirmation;
